
const state={
  bannerImgIndex: 1,  //初始化
};

const getters={
  renderImgIndex(state){ 
    return state.bannerImgIndex;
  }
};
const mutations={
  changeImgIndex(state,items){ 
    state.bannerImgIndex = items;
   }
};
const actions={
  changeImgIndexs(context,item){ //触发mutations里面的pushCollects ,传入数据形参item 对应到items
    context.commit('changeImgIndex',item);
  }
};
export default {
  namespaced:true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/goodsInfoBanner.js